


































































































































































import BaseButton from '@/components/base-button.vue';
import Vue from 'vue';
import VueCompositionAPI, {
  defineComponent,
  computed,
} from '@vue/composition-api';
import BackBtn from '@/components/back-btn.vue';
// @ts-ignore
import ConfidenceMarker from '@/components/confidence-marker.vue';
import {
  Hospital,
  HospitalStatusDetails,
  ConfidenceLevel,
  ItemStatus,
} from '../store/types';
import { dropReport, getHospitalDetails, loadHospitalDetails } from '../store';
import { useRouter, RouterAliases } from '@/router';
Vue.use(VueCompositionAPI);

const Hospitals = (hospitalId: string, visitor: boolean) => {
  loadHospitalDetails(hospitalId);

  const hospitalDetails = computed<HospitalStatusDetails | undefined>(() => {
    return getHospitalDetails(hospitalId);
  });

  const hospital = computed<Hospital | undefined>(() => {
    return hospitalDetails.value?.hospital;
  });

  const report = () => {
    const router = useRouter();
    router.push({
      name: RouterAliases.HOSPITAL_REPORT,
      params: { hospitalId, step: '1' },
    });
  };

  const reportGeneral = () => {
    const router = useRouter();
    router.push({
      name: RouterAliases.REPORT_GENERAL_STATUS,
      params: { hospitalId },
    });
  };

  const convertValueIntoString = (value: ItemStatus | undefined): string => {
    if (!value) {
      return '?';
    }
    const resultNumber = value?.available?.value || 0;
    const confidence =
      value?.available?.confidence || ConfidenceLevel.UNSPECIFIED;
    if (confidence === ConfidenceLevel.UNSPECIFIED) {
      return '?';
    }
    return resultNumber.toString();
  };

  const waitTime = computed(() => {
    const hospitalWaitingTime =
      hospitalDetails?.value?.status?.current_wait_time_seconds?.value || 0;
    const confidenceLevel =
      hospitalDetails?.value?.status?.current_wait_time_seconds?.confidence ||
      ConfidenceLevel.UNSPECIFIED;

    if (confidenceLevel === ConfidenceLevel.UNSPECIFIED) {
      return '?';
    }
    const hours = Math.floor(hospitalWaitingTime / 60 / 60);
    const minutes = Math.floor(hospitalWaitingTime / 60) - hours * 60;
    return hours ? `${hours}h` : `${minutes}m`;
  });

  const icuBeds = computed(() => {
    return convertValueIntoString(hospitalDetails.value?.status?.icu_beds);
  });
  const ventilators = computed(() => {
    return convertValueIntoString(
      hospitalDetails.value?.status?.adult_ventilators,
    );
  });
  const beds = computed(() => {
    return convertValueIntoString(hospitalDetails.value?.status?.beds);
  });

  const navigationUrl = computed<string | undefined>(() => {
    if (hospital.value == null) {
      return;
    }
    const { location } = hospital.value;
    const address = `${location.address_line1} ${location.address_line2 ||
      ''} ${location.city} ${location.state_province}`;
    return `https://www.google.com/maps/dir/?api=1&destination=${address}&dir_action=navigate`;
  });
  const status = computed<string>(() => {
    return hospitalDetails.value?.status?.source || 'No info';
  });

  const reportText = computed(() => {
    let text = visitor ? 'Currently here? ' : '';
    text += 'Report the specific status';
    return text;
  });

  const waitTimeConfidence = computed(() => {
    return (
      hospitalDetails.value?.status?.current_wait_time_seconds?.confidence ||
      ConfidenceLevel.UNSPECIFIED
    );
  });
  const bedsConfidence = computed(() => {
    return (
      hospitalDetails.value?.status?.beds?.available?.confidence ||
      ConfidenceLevel.UNSPECIFIED
    );
  });
  const icuBedsConfidence = computed(() => {
    return (
      hospitalDetails.value?.status?.icu_beds?.available?.confidence ||
      ConfidenceLevel.UNSPECIFIED
    );
  });
  const ventilatorsConfidence = computed(() => {
    return (
      hospitalDetails.value?.status?.adult_ventilators?.available?.confidence ||
      ConfidenceLevel.UNSPECIFIED
    );
  });

  return {
    hospital,
    report,
    reportGeneral,
    navigationUrl,
    waitTime,
    reportText,
    status,
    icuBeds,
    ventilators,
    beds,
    waitTimeConfidence,
    bedsConfidence,
    icuBedsConfidence,
    ventilatorsConfidence,
  };
};

const HospitalDetailComponent = defineComponent({
  components: {
    BaseButton,
    BackBtn,
    ConfidenceMarker,
  },
  props: {
    hospitalId: {
      type: String,
      required: true,
    },
    visitor: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    dropReport();
    return { ...Hospitals(props.hospitalId, Boolean(props.visitor)) };
  },
});

export default HospitalDetailComponent;
